/**
 * Copyright(c) 2022 Fenix Outdoor International AG.
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Fenix ("Confidential
 * Information"). You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the contract agreement you entered into with Fenix.
 *
 */
import React from "react";
import PropTypes from "prop-types";
import SearchEmpty from "../assets/images/svg/search-empty.svg";
import Spinner from "../core/Spinner";

const NoResult = (props) => {
  const {
    isLoading,
  } = props;

  return (
    <>
      {isLoading ? (
        <>
          <div className="spinner-loading d-flex align-items-center justify-content-center">
            <Spinner />
          </div>
        </>
      ) : (
        <>
          <div className="no-result-outer">
            <img src={SearchEmpty} alt="" />
            <h6>No Records Found</h6>
          </div>
        </>
      )}

    </>
  );
};

NoResult.propTypes = {
  isLoading: PropTypes.bool.isRequired,
};

export default NoResult;
